<template>
  <div class="receipt-image-viewer">
    <div class="receipt-image-wrap" :style="{ height: wrapHeight }">
      <!-- view=FitH pins the embedded PDF viewer to fit-page-width mode, so
           widening the iframe magnifies the document. Without it the viewer
           auto-fits the page to whatever viewport it gets and the zoom
           buttons only resize the dark frame around an unchanged page.
           Height stays 100% (not zoom-scaled) — vertical reading uses the
           viewer's own scrollbar; scaling height too produced a second outer
           vertical scrollbar next to the viewer's. -->
      <iframe
        v-if="imageUrl && isPdf"
        :src="imageUrl + '#toolbar=0&navpanes=0&view=FitH'"
        class="receipt-pdf"
        :style="{ width: (zoomLevel * 100) + '%' }"
        title="Receipt PDF"
      />
      <img
        v-else-if="imageUrl"
        :src="imageUrl"
        alt="Receipt"
        class="receipt-image"
        :style="{ width: (zoomLevel * 100) + '%' }"
      />
      <div v-else-if="errored" class="receipt-image-fallback">
        <i class="fas fa-image"></i>
        <span>Image unavailable</span>
      </div>
      <div v-else class="receipt-image-fallback">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
    </div>
    <div v-if="imageUrl" class="zoom-pill">
      <button
        type="button"
        class="zoom-btn"
        :disabled="zoomLevel <= ZOOM_MIN"
        @click="zoomOut"
        aria-label="Zoom out"
      >&minus;</button>
      <button
        type="button"
        class="zoom-btn"
        :disabled="zoomLevel >= ZOOM_MAX"
        @click="zoomIn"
        aria-label="Zoom in"
      >+</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReceiptImageViewer',

  props: {
    imageUrl: {
      type: String,
      default: null
    },
    contentType: {
      type: String,
      default: null
    },
    errored: {
      type: Boolean,
      default: false
    },
    wrapHeight: {
      type: String,
      default: '332px'
    }
  },

  data() {
    return {
      zoomLevel: 1,
      ZOOM_MIN: 0.5,
      ZOOM_MAX: 3,
      ZOOM_STEP: 0.25
    }
  },

  computed: {
    isPdf() {
      return this.contentType === 'application/pdf'
    }
  },

  watch: {
    imageUrl() {
      this.zoomLevel = 1
    }
  },

  methods: {
    zoomIn() {
      var next = Math.round((this.zoomLevel + this.ZOOM_STEP) * 100) / 100
      if (next > this.ZOOM_MAX) next = this.ZOOM_MAX
      this.zoomLevel = next
    },

    zoomOut() {
      var next = Math.round((this.zoomLevel - this.ZOOM_STEP) * 100) / 100
      if (next < this.ZOOM_MIN) next = this.ZOOM_MIN
      this.zoomLevel = next
    }
  }
}
</script>

<style lang="scss" scoped>
.receipt-image-viewer {
  position: relative;
  width: 100%;
}

.receipt-image-wrap {
  position: relative;
  width: 100%;
  overflow: auto;
  border-radius: 3px;
  background-color: #f5f5f5;
}

.receipt-image {
  display: block;
  height: auto;
  max-width: none;
  margin: 0 auto; /* center when zoomed below container width */
  transition: width 0.15s ease;
}

.receipt-pdf {
  display: block;
  border: 0;
  height: 100%;
  margin: 0 auto; /* center when zoomed below container width */
  transition: width 0.15s ease;
}

.receipt-image-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  color: #999;
  font-size: 14px;

  i { font-size: 24px; }
}

.zoom-pill {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 16px;
  background-color: #333;
  border-radius: 16px;
  padding: 8px 16px;

  .zoom-btn {
    background: transparent;
    border: 0;
    padding: 0;
    margin: 0;
    color: #fff;
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    min-width: 16px;
    height: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-transactions/ReceiptImageViewer.vue